function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import "./Objectives.css";
import _ from "lodash";
import { completedMilestone } from "../../redux/actions/game";

var ObjectivePanel = function ObjectivePanel() {
  var _useSelector = useSelector(function (state) {
    return state;
  }),
      scores = _useSelector.scores,
      game = _useSelector.game;

  var _useState = useState({
    percent: 0,
    batch: 0
  }),
      _useState2 = _slicedToArray(_useState, 2),
      score = _useState2[0],
      setScore = _useState2[1];

  var dispatch = useDispatch();
  useEffect(function () {
    // If there are no scores return...
    if (!hasScores()) {
      return;
    }

    var percentage = calculateScore(scores);
    var batchNumber = score.batch + 1; //Update UI with local state

    setScore({
      percent: percentage,
      batch: batchNumber
    });
  }, [scores]);
  useEffect(function () {
    // When the score updates, check to see if they completed the game...
    if (game.completed) {
      return;
    }

    if (score.percent == 0) {
      return;
    }

    var winState = checkFinishStateByDifficulty(game.game_settings.difficulty);

    if (winState) {
      dispatch(completedMilestone(game));
    }
  }, [score]); // Returns true if passed. False if not.

  var checkFinishStateByDifficulty = function checkFinishStateByDifficulty(level) {
    switch (level) {
      default:
      case "level1":
      case "level2":
      case "level3":
        return playedAtleastTenBatches(scores) && scoreHigherThanPercent(90, scores);
    }
  };

  var playedAtleastTenBatches = function playedAtleastTenBatches(scores) {
    return scores.length >= 10;
  };

  var scoreHigherThanPercent = function scoreHigherThanPercent(percentage, scores) {
    return percentage <= Math.round(_.sum(last10Scores(scores)) / last10Scores(scores).length);
  };

  var hasScores = function hasScores() {
    return scores.length > 0 ? true : false;
  };

  var calculateScore = function calculateScore(scores) {
    return Math.round(_.sum(last10Scores(scores)) / last10Scores(scores).length);
  };

  var last10Scores = function last10Scores(scores) {
    return _.takeRight(scores, 10);
  };

  var isCompletedStateClass = function isCompletedStateClass() {
    return game.completed ? " green" : "";
  };

  var getScoreColor = function getScoreColor() {
    if (playedAtleastTenBatches(scores)) {
      if (checkFinishStateByDifficulty(game.game_settings.difficulty)) {
        return " background-green";
      } else {
        return " background-orange";
      }
    } else {
      return " background-whitesmoke";
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "objectives-panel panel--round"
  }, /*#__PURE__*/React.createElement("div", {
    className: "objective-header panel--round__header"
  }, /*#__PURE__*/React.createElement("b", null, "Objective")), /*#__PURE__*/React.createElement("div", {
    className: "objective-body panel--round__body flex-row-container" + isCompletedStateClass()
  }, /*#__PURE__*/React.createElement("div", {
    className: "percent-box" + getScoreColor()
  }, /*#__PURE__*/React.createElement("span", {
    className: "percent-number"
  }, score.percent, "%")), /*#__PURE__*/React.createElement("div", {
    className: "flex-column-container info-box"
  }, /*#__PURE__*/React.createElement("div", {
    className: "goal-text"
  }, "Achieve ", /*#__PURE__*/React.createElement("b", null, 90, "%"), " correct over ", /*#__PURE__*/React.createElement("b", null, "10"), " consecutive batches."), /*#__PURE__*/React.createElement("div", {
    className: "batch-text"
  }, /*#__PURE__*/React.createElement("b", null, "Batch #", score.batch)))));
};

export { ObjectivePanel };